import { MonthlyTeamPlanningUser } from "./MonthlyTeamPlanningUser";
import { dateToAAAAMMJJ, dateWithoutHour, intToDay, firstLetterCapital } from "../../functions";

const MonthlyTeamPlanning = (props) => {
    const {
        startDate,
        endDate,
        planning,
        users,
        selectedTimeSlots,
        publicHolidays,
        headcountByDayKey,
        onNavigateMonth,
    } = props;

    const mtpStartDate = dateWithoutHour(startDate);
    const mtpEndDate = dateWithoutHour(endDate);

    function handleClickDate(val, ctrlKey) {
        props.onClickDate(val, ctrlKey);
    };

    function handleClickTimeSlots(tsId, ctrlKey) {
        props.onClickTimeSlots(tsId, ctrlKey);
    };
    const allDates = () => {
        let arrayOfDate = [];
        let aDate = dateWithoutHour(mtpStartDate);
        while (aDate <= mtpEndDate) {
            arrayOfDate.push(dateWithoutHour(aDate));
            aDate.setDate(aDate.getDate() + 1);
        }
        return arrayOfDate;
    }

    const planningWithDateAndUsers = () => {
        const aResult = users.map((usr) => {

            const aPlanningUser = allDates().map((aDate) => {
                const aDay = {
                    datePlanning: dateWithoutHour(aDate),
                    timeSlots: planning && planning.filter((pl) => {
                        return (dateWithoutHour(pl.start_date).toDateString() == dateWithoutHour(aDate).toDateString() && pl.user_id == usr.id)
                    }),
                }
                return aDay;
            })
            return {
                userId: usr.id,
                userName: (usr?.last_name || "") + [" "] + (usr?.first_name || ""),
                planning: aPlanningUser,
            };
        });

        return aResult;
    }

    // const columns = [...new Array(7)].map((val, index) => (index + 1) % 7);
    const percentDay = allDates().length > 0 ? (85 / allDates().length).toFixed(2) : 0;
    const percentUsr = (100 - (percentDay * allDates().length)).toFixed(2);
    const stylePercentDay = {
        width: percentDay + '%',
    }
    const stylePercentUsr = {
        width: percentUsr + '%',
    }

    const isPublicHoliday = (date) => {
        return publicHolidays.some(holiday => holiday.date == dateToAAAAMMJJ(date, "-"));
    }

    const render = (
        <div className="m-0 text-xs relative">
            {typeof onNavigateMonth === "function" ? (
                <>
                    <button
                        type="button"
                        className="hidden sm:flex items-center justify-center absolute left-0 top-1/2 -translate-y-1/2 -translate-x-10 h-8 w-8 rounded-md border border-gray-200 bg-white text-gray-600 hover:text-gray-900 hover:border-gray-300 shadow-xs"
                        title="Mois précédent"
                        aria-label="Mois précédent"
                        onClick={() => onNavigateMonth(-1)}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-4 w-4">
                            <path d="M15 18l-6-6 6-6" />
                        </svg>
                    </button>
                    <button
                        type="button"
                        className="hidden sm:flex items-center justify-center absolute right-0 top-1/2 -translate-y-1/2 translate-x-10 h-8 w-8 rounded-md border border-gray-200 bg-white text-gray-600 hover:text-gray-900 hover:border-gray-300 shadow-xs"
                        title="Mois suivant"
                        aria-label="Mois suivant"
                        onClick={() => onNavigateMonth(1)}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-4 w-4">
                            <path d="M9 18l6-6-6-6" />
                        </svg>
                    </button>
                </>
            ) : null}
            <div className="w-full p-0 flex m-1">
                <div className="w-full flex border-t border-l border-b">
                    <div key="user" style={stylePercentUsr} className="border-r flex py-1 justify-center">
                        
                    </div>
                    {allDates().map((day, index) =>
                        <div key={index} style={stylePercentDay} className={"border-r flex py-1 justify-center " + (isPublicHoliday(day) ? "text-red-500" : "text-slate-700")}>
                            {firstLetterCapital(intToDay(day.getDay())).slice(0,2)}<br/>{day.getDate()}
                        </div>
                    )}
                </div>
            </div>
            <>
                {planningWithDateAndUsers().map((pl) => (
                    <div key={pl.userId} className="w-full p-0 flex flex-wrap m-1 border">
                        {<MonthlyTeamPlanningUser
                            key={pl.userId}
                            userId={pl.userId}
                            userName={pl.userName}
                            planning={pl.planning}
                            allDates={allDates}
                            onClickDate={handleClickDate}
                            onClickTimeSlots={handleClickTimeSlots}
                            selectedTimeSlots={selectedTimeSlots}
                        />}
                    </div>
                ))
                }
            </>
            {headcountByDayKey ? (
                <div className="w-full p-0 flex m-1">
                    <div className="w-full flex border-t border-l border-b bg-slate-50">
                        <div
                            key="headcount-label"
                            style={stylePercentUsr}
                            className="border-r flex py-1 px-2 justify-start font-semibold text-slate-700"
                        >
                            Effectif
                        </div>
                        {allDates().map((day, index) => {
                            const dayKey = dateToAAAAMMJJ(day, "-");
                            const count = headcountByDayKey?.[dayKey] ?? "";
                            return (
                                <div
                                    key={index}
                                    style={stylePercentDay}
                                    className="border-r flex py-1 justify-center font-semibold text-slate-900 tabular-nums"
                                >
                                    {count}
                                </div>
                            );
                        })}
                    </div>
                </div>
            ) : null}
        </div>
    )

    return render;
};

export default MonthlyTeamPlanning;